import { Link } from "react-router-dom";
import { useState } from "react";
import { Sparkles, Mail, Phone, MapPin, Instagram, Facebook, Youtube } from "lucide-react";
import { subscribeNewsletter } from "../lib/api";
import { toast } from "sonner";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await subscribeNewsletter(email);
      toast.success("Subscribed. Welcome to the Astrohomeopathy circle.");
      setEmail("");
    } catch {
      toast.error("Subscription failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="site-footer" className="relative bg-[#0F172A] text-white overflow-hidden">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_top_right,#0EA5E9_0%,transparent_50%),radial-gradient(circle_at_bottom_left,#D4AF37_0%,transparent_50%)]" />
      <div className="container-page relative py-20 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="https://customer-assets.emergentagent.com/job_astrohomeo-pro/artifacts/xtgzo2ot_121471.jpg" alt="Astrohomeopathy® logo" className="w-14 h-14 object-contain bg-white rounded-xl p-1" />
            <span className="font-serif text-xl" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Astrohomeopathy<sup className="text-[#D4AF37] text-xs">®</sup>
            </span>
          </div>
          <p className="text-slate-300 leading-relaxed max-w-md text-sm">
            Official Research & Education Portal by Dr. Manish Misra — a classical homeopathic paradigm integrated with Vedic astrological principles.
          </p>

          <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md" data-testid="footer-newsletter-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Your email"
              data-testid="footer-newsletter-email"
              className="flex-1 rounded-full bg-white/10 backdrop-blur border border-white/20 px-5 py-3 text-sm focus:outline-none focus:border-[#D4AF37] placeholder:text-white/50"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="footer-newsletter-submit"
              className="rounded-full bg-[#D4AF37] px-6 py-3 text-sm font-medium hover:bg-[#B5952F] transition disabled:opacity-60"
            >
              {loading ? "..." : "Subscribe"}
            </button>
          </form>
        </div>

        <div>
          <h4 className="text-sm tracking-[0.2em] uppercase text-[#D4AF37] mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/about" className="hover:text-white">About Dr. Misra</Link></li>
            <li><Link to="/what-is-astrohomeopathy" className="hover:text-white">Astrohomeopathy®</Link></li>
            <li><Link to="/planets" className="hover:text-white">Planet Explorer</Link></li>
            <li><Link to="/materia-medica" className="hover:text-white">Materia Medica</Link></li>
            <li><Link to="/case-studies" className="hover:text-white">Case Studies</Link></li>
            <li><Link to="/blog" className="hover:text-white">Journal</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm tracking-[0.2em] uppercase text-[#D4AF37] mb-4">Reach us</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-start gap-2"><Phone size={16} className="mt-1 shrink-0" /> +91 9559093555 (WhatsApp / Mobile)</li>
            <li className="flex items-start gap-2"><MapPin size={16} className="mt-1 shrink-0" /><span>Dr. Manish Homeopathic Clinic<br />Shop No. 6, Ground Floor, LDA Complex,<br />Vishwas Khand-3, Gomti Nagar<br />Lucknow – 226010, U.P., India</span></li>
          </ul>
          <div className="flex gap-3 mt-6">
            <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10"><Instagram size={16} /></a>
            <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10"><Facebook size={16} /></a>
            <a href="#" aria-label="YouTube" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-white/10"><Youtube size={16} /></a>
          </div>
        </div>
      </div>
      <div className="relative border-t border-white/10">
        <div className="container-page py-6 flex flex-col md:flex-row items-center justify-between text-xs text-slate-400 gap-2">
          <div>© {new Date().getFullYear()} Astrohomeopathy® · Official Research & Education Portal by Dr. Manish Misra. All rights reserved.</div>
          <div>Astrohomeopathy® is a registered trademark. Educational content — not medical prescription.</div>
        </div>
      </div>
    </footer>
  );
};
